/** Shared MatDialog sizing for FMT modals — caps width on narrow viewports. */
export function fmtDialogConfig(width: string, extra?: Record<string, unknown>) {
	return {
		width,
		maxWidth: 'calc(100vw - 1.5rem)',
		maxHeight: '90vh',
		panelClass: 'fmt-dialog',
		...extra,
	};
}
